<template>
  <div class="index">
    <div class="img">
      <img class="bg" src="../assets/images/bg.png" alt="" />
      <img
        class="icon_onebuy"
        src="../assets/images/icon_onebuy.png"
        @click="showDialog"
        alt=""
      />
    </div>
    <div class="dialog" v-if="isDialog" @touchmove.prevent>
      <div class="card">
        <div class="label">
          还剩<span>{{ num }}</span
          >个席位
        </div>
        <div class="clear"></div>
        <div class="mobile">
          <div class="icon">
            <img src="../assets/images/icon_shouji@2x.png" alt="" />
          </div>
          <div class="inp">
            <input
              @focus="error = ''"
              @blur="mobileBlur"
              type="text"
              placeholder="请输入手机号"
              v-model="params.mobile"
            />
          </div>
        </div>
        <div class="err">{{ error }}</div>
        <div class="code">
          <div class="left_code">
            <div class="icon">
              <img src="../assets/images/icon_yanzhengma@2x.png" alt="" />
            </div>
            <div class="inp">
              <input
                @focus="errorT = ''"
                type="text"
                placeholder="请输入验证码"
                v-model="formData.code"
              />
            </div>
          </div>
          <div class="right_icon">
            <button
              :class="codeDisabled ? 'disabledCls' : ''"
              :disabled="codeDisabled"
              @click="getCode"
            >
              {{ codeMsg }}
            </button>
          </div>
        </div>
        <div class="icon_tijiao">
          <button @click="signUp">提交报名</button>
        </div>
        <div class="errT">{{ errorT }}</div>
        <div class="close">
          <img
            @click="isDialog = !isDialog"
            src="../assets/images/icon_close.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <Tip v-if="tipShow"></Tip>
  </div>
</template>

<script>
import { getCodeApi, signUpApi, getOrderApi } from "../api/index";
export default {
  components: {
    Tip: () => import("../views/tip.vue"),
  },
  data() {
    return {
      tipShow: false,
      isDialog: false,
      codeMsg: "获取验证码",
      num: "",
      error: "",
      errorT: "",
      codeDisabled: false,
      params: {
        mobile: "",
        event: "yyg",
      },
      formData: {
        mobile: "",
        code: "",
        title: "造价一元购（网校-YD）",
        url: "http://m.dalischool.com/tui/yygwx/",
      },
    };
  },
  created() {
    let token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      getOrderApi().then((res) => {
        localStorage.setItem("oneBuyUserInfo", JSON.stringify(res.data));
      });
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("weixin") !== -1) {
      this.tipShow = true;
    }
  },
  methods: {
    showDialog() {
      let info = JSON.parse(localStorage.getItem("oneBuyUserInfo"));
      let token = JSON.parse(localStorage.getItem("token"));
      if (token && info) {
        if (
          info.list ? info.list.status === "created" : info.status === "created"
        ) {
          this.$router.push("/buy");
        } else {
          this.$router.push("/paySucceed");
        }
      } else {
        this.isDialog = !this.isDialog;
        this.createSixNum();
      }
    },
    // 点击获取验证码
    async getCode() {
      try {
        if (this.codeDisabled) return;
        let time = 60;

        let rule =
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!this.params.mobile) return (this.error = "请输入手机号");
        if (!rule.test(this.params.mobile))
          return (this.error = "手机号格式错误");

        this.codeDisabled = true;

        if (time !== 60) {
          clearInterval(setInt);
        }

        let setInt = setInterval(() => {
          time--;
          this.codeMsg = time + "秒后再次获取";
          if (time === 0) {
            clearInterval(setInt);
            this.codeDisabled = false;
            this.codeMsg = "获取验证码";
            time = 60;
          }
        }, 1000);
        let res = await getCodeApi(this.params);
        if (res.code === 0) {
          this.$toast(res.msg);
          this.codeMsg = "获取验证码";
          this.codeDisabled = false;
          time = 60;
          clearInterval(setInt);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 手机号输入框失去焦点
    mobileBlur() {
      try {
        let rule =
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!this.params.mobile) return (this.error = "请输入手机号");
        if (!rule.test(this.params.mobile))
          return (this.error = "手机号格式错误");
      } catch (error) {
        console.log(error);
      }
    },
    async signUp() {
      try {
        let rule =
          /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        if (!this.params.mobile) return (this.error = "请输入手机号");
        if (!rule.test(this.params.mobile))
          return (this.error = "手机号格式错误");
        if (!this.formData.code) return (this.errorT = "请输入验证码");
        this.formData.mobile = this.params.mobile;

        let res = await signUpApi(this.formData);
        if (res.code === 1) {
          localStorage.setItem(
            "oneBuyUserInfo",
            JSON.stringify({ ...res.data, ...this.formData })
          );
          localStorage.setItem("token", JSON.stringify(res.data.token));
          this.$router.push("/buy");
        } else {
          this.errorT = "验证码不正确";
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取3位数随机数
    createSixNum() {
      let min = 200;
      let max = 300;
      this.num = "";
      this.num += Math.floor(Math.random() * (max - min + 1) + min);
    },
  },
};
</script>

<style lang="less" scoped>
.img {
  .bg {
    width: 100%;
  }
  .icon_onebuy {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
.dialog {
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  .card {
    background-color: #fff;
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 14px;
    .label {
      background-color: #ffa002;
      float: left;
      padding: 8px;
      border-radius: 14px 0 14px 0;
      color: #fff;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      span {
        font-size: 28px;
        font-family: DIN;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .mobile {
      display: flex;
      height: 45px;
      border: 1px solid #bebebe;
      margin: 44px 21px 36px;
      align-items: center;
      .icon {
        width: 24px;
        height: 24px;
        margin: 0 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .inp {
        font-size: 19px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #bbbbbb;
      }
    }
    .code {
      display: flex;
      height: 45px;
      margin: 44px 21px 36px;
      align-items: center;
      .left_code {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        border: 1px solid #bebebe;
        .icon {
          width: 24px;
          height: 24px;
          margin: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .inp {
          width: 100%;
          font-size: 19px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #bbbbbb;
          input {
            width: 100%;
          }
        }
      }
      .right_icon {
        float: 1;
        height: 44px;
        margin-left: 13px;
        button {
          outline: none;
          border: none;
          background-color: #ffa002;
          height: 100%;
          width: 100%;
          font-size: 16px;
          padding: 10px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #fff;
          border-radius: 8px;
        }
      }
    }
    .icon_tijiao {
      height: 45px;
      padding: 0 21px 20px;
      button {
        outline: none;
        border: none;
        width: 100%;
        background-color: #ffa002;
        height: 44px;
        font-size: 26px;
        border-radius: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #fff;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: -40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.clear {
  clear: both;
  zoom: 1;
}
.err,
.errT {
  position: absolute;
  left: 20px;
  color: red;
  font-size: 14px;
}
.err {
  top: 155px;
}
.errT {
  top: 240px;
}
.disabledCls {
  background-color: #ccc !important;
}
</style>
